// extracted by mini-css-extract-plugin
export default {"dialog":"RenameFileDialog_dialog__+w4YC","actionsRow":"RenameFileDialog_actionsRow__XIme-"};